import styled from 'styled-components';

import { Flex } from '../../../common/ui/Flex';
import { get } from '../../../common/ui/get';

export const ApproverListWrapper = styled(Flex)`
    flex-direction: column;
    row-gap: ${get('space.4')}px;
`;
